<div class="flex-column" *ngIf="isVisible()">

<!--     <mat-form-field appearance="outline">
        <input matInput placeholder="Contraseña" name="pass" [formControl]="pass" (keyup.enter)="onKeyUp($event)">
    </mat-form-field> -->

    <mat-form-field *ngIf="!isLoading()">
        <mat-label>Contraseña</mat-label>
        <input matInput [formControl]="pass" [(ngModel)]="password"  (keyup.enter)="onKeyUp($event)">
    </mat-form-field>
      
    <mat-spinner *ngIf="isLoading()"></mat-spinner>
      
     <div class="center">
        <a href="javascript: void(0)" (click)="validatePass()" class="round-btn">Abrir</a>
     </div>

     <!-- <button mat-button mat-raised-button type="submit" (click)="validatePass()">
        <span>Ok</span>
    </button> -->
</div>



 